'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { getENV, OneTrustScripts, useCacheKey, useDeviceType, useOptimizely } from '@libs/common-next';
import { DigitalData } from '../DigitalData';
import { useCustomerKey } from './hooks';
export function TrackingScripts() {
  const $ = _c(17);
  const {
    customerKey
  } = useCustomerKey();
  const {
    cookies
  } = useCacheKey();
  const {
    init
  } = useOptimizely();
  const pathname = usePathname();
  const {
    deviceType
  } = useDeviceType();
  let t0;
  if ($[0] !== cookies) {
    t0 = cookies.get("x-petm-team");
    $[0] = cookies;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const team = t0;
  let t1;
  if ($[2] !== deviceType || $[3] !== init || $[4] !== pathname || $[5] !== team) {
    t1 = () => {
      if (pathname) {
        init({
          pathname,
          deviceType,
          team
        });
      }
    };
    $[2] = deviceType;
    $[3] = init;
    $[4] = pathname;
    $[5] = team;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== deviceType || $[8] !== init || $[9] !== pathname) {
    t2 = [init, pathname, deviceType];
    $[7] = deviceType;
    $[8] = init;
    $[9] = pathname;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getENV("NEXT_PUBLIC_ONETRUST_ENABLED");
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const isOneTrustEnabled = t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DigitalData />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== customerKey) {
    t5 = isOneTrustEnabled && <OneTrustScripts data-testid="onetrust-script" customerKey={customerKey} />;
    $[13] = customerKey;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}